module.exports = __webpack_public_path__ + "static/media/scrnsht.4f216ec3.png";